export default __webpack_public_path__ + "static/media/bhuvanLogo.db4b4b01.png";